var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error"},[_c('div',{staticClass:"error-content"},[_c('img',{staticClass:"error-content-img",attrs:{"src":_setup.errorImg,"alt":"empty"}}),_c('div',{staticClass:"error-content-title"},[_vm._v("请求失败，请稍后重试")]),_c('div',{staticClass:"error-content-btn",on:{"click":_setup.refresh}},[_vm._v("刷新")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }